import { ReactNode } from "react";
import { Box, Container } from "@mui/material";
import { useLocation } from 'react-router-dom';
import BG_IMAGE from "../assets/images/bg-image.png";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation(); // Get the current location
  const isHomePage = location.pathname === '/home'; // Check if the current path is the home page

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    backgroundImage: `url(${BG_IMAGE})`,
    backgroundPosition: "center",
    backgroundRepeat: "repeat",
    backgroundSize: "cover",
  };

  return (
    <Container maxWidth={false} disableGutters sx={containerStyle} className={isHomePage ? "container-fluid" : ""}>
      {isHomePage ? (
        <div className="banner">
            <div className="container text-center text-white">  
            </div>
        </div>
      ) : (
        <Box display="flex" justifyContent="space-between" alignItems="center" margin={3}>
          <img
            src="https://graitec.com/uk/wp-content/uploads/sites/8/2022/05/logo-blue.svg"
            alt="logo"
          />
        </Box>
      )}
      <div className={isHomePage ? "container" : ""}>
        {children}
      </div>
    </Container>
  );
};

export default Layout;
